import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Snackbar,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function UserCreate() {
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    password: "",
    userRole: "BUSINESS_TEAM",
    created_at: "",
    created_by: "",
    created_by_ref: "",
    updated_at: "",
    updated_by: "",
    margin: 15,
    createdByName: "", // Added new field
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({ email: "", password: "", portal: "" });

  useEffect(() => {
    const currentUserRole = localStorage.getItem("userRole");

    const roleOptions = {
      SUPER_ADMIN: ["CLIENT", "BUSINESS_TEAM", "ADMIN"],
      BUSINESS_TEAM: ["CLIENT"],
    };

    setDropdownOptions(roleOptions[currentUserRole] || []);

    setFormData({
      email: "",
      name: "",
      password: "",
      userRole: "",
      created_at: new Date().toISOString(),
      created_by: localStorage.getItem("userRole"),
      created_by_ref: localStorage.getItem("ueserId"), // Fixed typo from "ueserId" to "userId"
      updated_at: new Date().toISOString(),
      updated_by: localStorage.getItem("userRole"),
      margin: 15,
      createdByName: localStorage.getItem("name"),
      updatedByName: localStorage.getItem("name"),
    });
  }, []);

  const [error, setError] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "margin") {
      // Prevent negative values
      const newValue = Math.max(0, parseInt(value, 10) || 0);
      setFormData((prev) => ({
        ...prev,
        [name]: newValue,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "email") {
      validateEmail(value);
    }

    if (name === "password") {
      validatePassword(value);
    }
  };

  const validateEmail = (email) => {
    if (!email) {
      setError((prev) => ({ ...prev, email: "Email is required" }));
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError((prev) => ({ ...prev, email: "Invalid email format" }));
      return false;
    }
    setError((prev) => ({ ...prev, email: "" }));
    return true;
  };

  const validatePassword = (password) => {
    if (!password) {
      setError((prev) => ({ ...prev, password: "Password is required" }));
      return false;
    }
    setError((prev) => ({ ...prev, password: "" }));
    return true;
  };

  const handleSave = async () => {
    const emailValid = validateEmail(formData.email);
    const passwordValid = validatePassword(formData.password);

    if (!emailValid || !passwordValid) {
      setSnackbarMsg("Please fix the errors before submitting.");
      setOpenSnackbar(true);
      return;
    }

    try {
      let requestData = { ...formData };

      // ✅ Margin logic
      if (formData.userRole !== "CLIENT") {
        delete requestData.margin;
      } else {
        requestData.margin = parseInt(formData.margin, 10);
      }

      const response = await fetch("https://api.exampladmedia.com/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      // =========================
      // ✅ SUCCESS
      // =========================
      if (response.ok) {
        const data = await response.json();

        const portalLink = "https://pricing.exampladmedia.com";
        const clipboardText = `Email: ${formData.email}
Password: ${formData.password}
Portal: ${portalLink}`;

        setModalData({
          email: formData.email,
          password: formData.password,
          portal: portalLink,
        });
        setOpenModal(true);

        try {
          await navigator.clipboard.writeText(clipboardText);
        } catch {
          const textarea = document.createElement("textarea");
          textarea.value = clipboardText;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }

        setSnackbarMsg(data?.message || "User created successfully.");
        setOpenSnackbar(true);

        setTimeout(() => {
          setOpenSnackbar(false);
          setFormData({
            email: "",
            name: "",
            password: "",
            userRole: "BUSINESS_TEAM",
            created_at: "",
            created_by: "",
            created_by_ref: "",
            updated_at: "",
            updated_by: "",
            margin: 15,
            createdByName: "",
          });
        }, 2000);

        return;
      }

      // =========================
      // ❌ ERROR (SHOW BACKEND ONLY)
      // =========================
      let errorMsg = "Something went wrong. Please try again.";

      try {
        const errorData = await response.json();
        errorMsg = errorData?.error || errorData?.message || errorMsg;
      } catch (e) { }

      setSnackbarMsg(errorMsg);
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 3000);

    } catch (error) {
      console.error("API Error:", error);
      setSnackbarMsg("Server error. Please try again later.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 3000);
    }
  };


  // const handleSave = async () => {
  //   const emailValid = validateEmail(formData.email);
  //   const passwordValid = validatePassword(formData.password);

  //   if (!emailValid || !passwordValid) {
  //     setSnackbarMsg("Please fix the errors before submitting.");
  //     setOpenSnackbar(true);
  //     return;
  //   }

  //   try {
  //     let requestData = { ...formData };

  //     if (formData.userRole !== "CLIENT") {
  //       delete requestData.margin;
  //     } else {
  //       requestData.margin = parseInt(formData.margin, 10);
  //     }

  //     const response = await fetch("https://api.exampladmedia.com/auth/register", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestData),
  //     });

  //     if (response.ok) {
  //       const data = await response.json();

  //       const portalLink = "https://pricing.exampladmedia.com";
  //       const clipboardText = `Email: ${formData.email}\nPassword: ${formData.password}\nPortal: ${portalLink}`;

  //       // await navigator.clipboard.writeText(clipboardText);
  //       setModalData({
  //         email: formData.email,
  //         password: formData.password,
  //         portal: portalLink,
  //       });
  //       setOpenModal(true);

  //       try {
  //         await navigator.clipboard.writeText(clipboardText);
  //       } catch {
  //         const textarea = document.createElement('textarea');
  //         textarea.value = clipboardText;
  //         document.body.appendChild(textarea);
  //         textarea.select();
  //         document.execCommand('copy');
  //         document.body.removeChild(textarea);
  //       }

  //       setSnackbarMsg(data.message || "User created and details copied to clipboard!");
  //       setOpenSnackbar(true);

  //       // Reset form fields after a short delay
  //       setTimeout(() => {
  //         setOpenSnackbar(false);
  //         setFormData({
  //           email: "",
  //           name: "",
  //           password: "",
  //           userRole: "BUSINESS_TEAM",
  //           created_at: "",
  //           created_by: "",
  //           created_by_ref: "",
  //           updated_at: "",
  //           updated_by: "",
  //           margin: 15,
  //           createdByName: "", // Reset new field
  //         });
  //       }, 2000);
  //     } else {
  //       console.error("Error saving form, Response Status:", response.status);
  //       const errorData = await response.json();
  //       setSnackbarMsg(errorData.error || "Something went wrong.");
  //       setOpenSnackbar(true);
  //       setTimeout(() => setOpenSnackbar(false), 2000);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     // setSnackbarMsg("An error occurred. Please try again.");
  //     setOpenSnackbar(true);
  //     setTimeout(() => setOpenSnackbar(false), 2000);
  //   }
  // };

  return (
    <DashboardLayout>
      <MDBox
        pt={3}
        pb={3}
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ overflow: "hidden" }}
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <h2 style={{ color: "white", margin: 0 }}>Create User</h2>
              </MDBox>
              <MDBox
                py={4}
                px={3}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="Name"
                      variant="outlined"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      error={!!error.name}
                      helperText={error.name}
                      sx={{ maxWidth: 400 }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="Email"
                      variant="outlined"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      error={!!error.email}
                      helperText={error.email}
                      sx={{ maxWidth: 400 }}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="Password"
                      variant="outlined"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      error={!!error.password}
                      helperText={error.password}
                      sx={{ maxWidth: 400 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="Created By Name"
                      variant="outlined"
                      name="createdByName"
                      value={formData.createdByName}
                      onChange={handleInputChange}
                      sx={{ maxWidth: 400 }}
                    />
                  </Grid> */}
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <FormControl fullWidth variant="outlined" sx={{ maxWidth: 400 }}>
                      <InputLabel>User Role</InputLabel>
                      <Select
                        label="User Role"
                        name="userRole"
                        value={formData.userRole}
                        onChange={handleInputChange}
                        sx={{ height: "40px" }}
                      >
                        {dropdownOptions.map((role) => (
                          <MenuItem key={role} value={role}>
                            {role === "ADMIN" ? "OPERATIONS" : role}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {formData.userRole === "CLIENT" && (
                    <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                      {/* <TextField
                        fullWidth
                        label="Margin"
                        variant="outlined"
                        name="margin"
                        type="number"
                        value={formData.margin === 0 ? "" : formData.margin}
                        onChange={handleInputChange}
                        sx={{
                          maxWidth: 400,
                          "& input[type=number]": {
                            MozAppearance: "textfield",
                          },
                          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
                            WebkitAppearance: "none",
                            margin: 0,
                          },
                        }}
                      /> */}
                      <TextField
                        fullWidth
                        label="Margin"
                        variant="outlined"
                        name="margin"
                        type="number"
                        defaultValue=""
                        onChange={handleInputChange}
                        sx={{ maxWidth: 400 }}
                      />

                    </Grid>
                  )}
                </Grid>
                <Box display="flex" justifyContent="center" mt={3} gap={2}>
                  <Button variant="contained" color="primary" style={{ color: "white" }} onClick={handleSave}>
                    Save
                  </Button>
                </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={openSnackbar} message={SnackbarMsg} autoHideDuration={2000} anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }} />
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>User Created</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1">
            <strong>Email:</strong> {modalData.email}
          </Typography>
          <Typography variant="body1">
            <strong>Password:</strong> {modalData.password}
          </Typography>
          <Typography variant="body1">
            <strong>Portal:</strong> <a href={modalData.portal} target="_blank" rel="noopener noreferrer">{modalData.portal}</a>
          </Typography>
          <Typography variant="caption" sx={{ mt: 2, display: "block", color: "green" }}>
            ✅ Details copied to clipboard
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default UserCreate;